import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import ReactModal from 'react-modal';
import { ToastContainer } from 'react-toastify';

import './index.scss';
import ImagePreviewModal from 'components_v3/ImagePreviewModal';
import Loader from 'components_v3/Loader';
import { ApiClientProvider } from 'context/api-client';
import { ImagePreviewProvider } from 'context/image-preview';
import { initializeGoogleTagManager } from 'google-tag-manager';
import PublicSnapshot from 'pages_v3/PublicSnapshot';
import retryRule from 'utils/retry';

import { initializeAnalytics } from './google-analytics';
import './i18n';

import 'react-toastify/dist/ReactToastify.css';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';


ReactModal.setAppElement('#root');

const App = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [queryClient, setQueryClient] = useState(null);

  useEffect(() => {
    // Check if we're at the root URL
    if (window.location.pathname === '/') {
      window.location.href = 'https://www.skydeck.ai';
      return;
    }

    const setupApp = () => {
      // Initialize analytics
      initializeAnalytics();
      initializeGoogleTagManager();

      // Create QueryClient
      const client = new QueryClient({
        defaultOptions: {
          queries: {
            retry: retryRule,
          },
        },
      });
      setQueryClient(client);

      setIsInitialized(true);
    };

    setupApp();
  }, []);

  if (!isInitialized || !queryClient) return <Loader />;

  return (
    <>
      <ToastContainer theme='dark' />
      <ApiClientProvider>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <ImagePreviewProvider>
            <PublicSnapshot />
            <ImagePreviewModal id='image-preview-modal' />
          </ImagePreviewProvider>
        </QueryClientProvider>
      </ApiClientProvider>
    </>
  );
};

createRoot(document.getElementById('root')).render(<App />);
